module.exports = __webpack_public_path__ + "static/media/our-team-background.b3a04172.jpg";